import { similarityFeatureDisplay } from "./similarSeasonsFeatureGlossary";

export function mlbSimilarityStatLabel(metric, fallback) {
  return similarityFeatureDisplay(metric, fallback).label;
}

export function formatMlbSimilarityStat(metric, value) {
  return similarityFeatureDisplay(metric).format(value);
}

export function mlbTeamLabel(teamId) {
  return teamId || null;
}

export function mlbTeamLogoId() {
  return null;
}

export const MLB_SIMILAR_SEASON_DISPLAY = {
  statLabel: mlbSimilarityStatLabel,
  formatStat: formatMlbSimilarityStat,
  teamLabel: mlbTeamLabel,
  teamLogoId: mlbTeamLogoId,
  ineligibleMessage:
    "This season is not in the similarity index. Seasons below the playing-time threshold (200 PA or 40 IP) or missing required stats are excluded.",
};
